import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { StoneLaterality, StoneLocation, StoneVerdict } from "../stones/types";

// Non-factory stone review state. Factory candidate decisions use the labeling API.
export const stoneVerdictsAtom = atomWithStorage<Record<string, StoneVerdict>>("stoneVerdicts", {});
export const stoneAttrEditsAtom = atomWithStorage<
  Record<string, { location?: StoneLocation; laterality?: StoneLaterality }>
>("stoneAttrEdits", {});
export const selectedStoneIdAtom = atom<string | null>(null);
